import useUserList from "./useUserList";
import { CommonUtils } from "utils";
import { SystemConstant } from "const";

export default function useDepartmentUserList(
  departmentId,
  unitId,
  searchValue = "",
  page = SystemConstant.ACTIVE_PAGINATION,
) {
  const { totalUsers } = useUserList();

  const departmentUserList = totalUsers
    .filter(user => user.departmentId === departmentId && user.unitId === unitId)
    .map(user => ({ label: user.name, id: user.accountId }));

  const departmentUserListFilter = totalUsers
    .filter(
      user =>
        isStateCondition(user) &&
        (user.name?.toLowerCase().includes(searchValue.toLowerCase()) ||
          user.mail?.includes(searchValue) ||
          user.phone?.includes(searchValue)) &&
        user.departmentId === departmentId &&
        user.unitId === unitId,
    )
    .map(user => ({ id: user.accountId, name: user.name, phone: user.phone, mail: user.mail }));

  const totalPages = Math.ceil(departmentUserListFilter.length / SystemConstant.USERS_LIMITED_NUMBER);

  return {
    departmentUserList,
    totalPages,
    currentPageUsers: CommonUtils.paginateFromArray(
      departmentUserListFilter,
      page,
      SystemConstant.USERS_LIMITED_NUMBER,
    ),
  };
}

const isStateCondition = user => {
  let stateCondition = false;
  if (user.state !== 0 && user.branchAccountState !== 0) stateCondition = true;
  return stateCondition;
};
